import { Expose } from "class-transformer";

export default class MessageTemplate {
  @Expose({ name: "message_type" }) messageType: string;
  @Expose() title: string;
  @Expose() body: string;
  @Expose() description: string;
  @Expose() active: boolean;
}
